<template>
  <section class="textHeader container">
    <h1>{{ page?.title }}</h1>
    <div v-if="page?.lead || page?.description" class="textHeader__Lead" :class="{ isNarrow }" v-html="page.lead || page.description" />
  </section>
</template>

<script setup>
  const { page } = usePage();
  const props = defineProps({
    narrowText: {
      type: Boolean,
      default: false
    }
  });

  const isNarrow = computed(() => props.narrowText);
</script>

<style lang="scss">
  @import url('@/assets/styles/components/_textHeader.scss');
</style>